// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1xHwa","signatureButtonsRight":"ModalSign_signatureButtonsRight__1KsCd"};